<template>
  <el-container class="pay-container">
    <el-header class="pay-header">您的账号已过期,请微信扫码支付</el-header>
    <el-main class="pay-main">
      <div>
        <img alt="微信支付" :src="`https://oss.jiaxiao.fun/wxpay.png`" style="width:430px;height:430px;"/>
        <div style="text-align:center;margin-top:20px;">
          <el-button type="success" @click="login">我已支付,尝试重新登录</el-button>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      month_fee: 2000
    }
  },
  methods: {
    login () {
      this.$router.replace('/login')
    }
  },
  mounted () {
    this.$http.get('/auth/info').then(response => {
      if (response.data.success) {
        this.month_fee = response.data.user.month_fee
      }
    })
  }
}
</script>


<style scoped>
.pay-container {
  min-height: 100vh;
  background: #F7F7F7;
}
.pay-header {
  background: #ededed;
  border-bottom: 1px solid #d9dee4;
  text-align: center;
  height: 50px !important;
  line-height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: red;
}
.pay-main {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Pay.vue